import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import {Router} from '@angular/router';


@Injectable()
export class ErrorsInterceptor implements HttpInterceptor {

    constructor(private messageService: MessageService,
                private translateService: TranslateService,
                private readonly router: Router) {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError((error: HttpErrorResponse) => {
                    if (error.status === 409) {
                        return throwError(error);
                    }
                    if (error.error && error.error.title) {
                        return this.handleError(error.error);
                    }
                    else if (error.error instanceof Blob && error.headers.get('content-type')?.includes('application') && error.headers.get('content-type')?.includes('json')) {
                        return this.blobToJson(error.error).pipe(
                            concatMap(jsonError => {
                                return this.handleError(jsonError);
                            })
                        );
                    }
                    else {
                        // let errorMsg = error.message || 'Erreur inconnue';
                        // this.messageService.add({ key: 'interceptor', severity: 'error', summary: 'Erreurs', detail: errorMsg });
                        return throwError(error);
                    }
                }));
    }

    private handleError(error: any): Observable<never> {
        let errorMsg = '';
        if (error?.detail === 'Not Authenticated') {
            this.router.navigate(['/']);
            return;
        }
        else {
            // BadRequestAlertException du serveur : la clé arrive dans `message` (« error.<clé> »), pas dans `errorKey`.
            const messageKey = typeof error.message === 'string' && error.message.startsWith('error.') ? error.message.substring(6) : null;
            const key = error.errorKey ?? messageKey;
            const translated = key ? this.translateService.instant(`error.server.${key}`, error) : null;
            errorMsg = translated && translated !== `error.server.${key}`
                ? translated
                : this.translateService.instant(`error.server.${error.title}`, error);
        }
        this.messageService.add({ key: 'interceptor', severity: 'error', summary: 'Erreurs', detail: errorMsg });
        errorMsg += `; Message: ${error.message}`;
        return throwError(errorMsg);
    }


    private blobToJson(blob: Blob): Observable<any> {
        return new Observable<any>(observer => {
            const reader = new FileReader();
            reader.onload = () => {
                const data = reader.result;
                observer.next(JSON.parse(data as string));
                observer.complete();
            };
            reader.onerror = error => observer.error(error);
            reader.readAsText(blob);
        });
    }
}
